import React from 'react';
import { useForm } from '@nerdgeschoss/react-use-form-library';
import { Button } from '../../../../../../components/Button/Button';
import { Form } from '../../../../../../components/Form/Form';
import { FormTextField } from '../../../../../../components/Form/TextField/FormTextField';
import { SubmitLine } from '../../../../../../components/SubmitLine/SubmitLine';
import { t } from '../../../../../../locales/translate';
import { handleError } from '../../../../../../model/notification';
import { updatePersonalization } from '../../../../../../model/ticket';

interface Props {
  ticket: {
    id: string;
    personalIdentifier: string;
  };
  onClose: () => void;
  onSuccess: () => void;
}

export function TicketPersonalizationForm({ ticket, onClose, onSuccess }: Props): JSX.Element {
  const { model, fields, onSubmit, valid, submissionStatus } = useForm({
    model: {
      id: ticket.id,
      personalIdentifier: ticket.personalIdentifier,
    },
    onSubmit: async () => {
      try {
        if (model.id && model.personalIdentifier) {
          await updatePersonalization({
            itemId: model.id,
            personalIdentifier: model.personalIdentifier,
          });
          onSuccess();
        }
      } catch (error) {
        handleError(error);
      }
    },
  });

  return (
    <Form
      onSubmit={async () => {
        onSubmit();
      }}
    >
      <FormTextField
        label={t.model.ticket.personalIdentifier}
        {...fields.personalIdentifier}
        onChange={(v) => fields.personalIdentifier.onChange(v || '')}
      />
      <SubmitLine>
        <Button title={t.actions.cancel('')} onClick={onClose} />
        <Button
          title={t.actions.save('')}
          type="primary"
          loading={submissionStatus === 'submitting'}
          disabled={!valid}
          isSubmit
        />
      </SubmitLine>
    </Form>
  );
}
